import Api from '@/services/Api'

export default {
  high (params) {
    return Api().get('reports/prices/-1?sku=' + (params.sku ? params.sku : '') + '&ean=' + (params.ean ? params.ean : '') + '&name=' + (params.name ? params.name : '') + '&page=' + (params.page ? params.page : ''))
  },
  low (params) {
    return Api().get('reports/prices/1?sku=' + (params.sku ? params.sku : '') + '&ean=' + (params.ean ? params.ean : '') + '&name=' + (params.name ? params.name : '') + '&page=' + (params.page ? params.page : ''))
  }
}



// WEBPACK FOOTER //
// ./src/services/ReportsService.js